import {GameDescriptionDefaultTextBox} from './game-description-text.default.box';
import {styledByTheme} from "../../../../../../../themes/architecture/styled-by-theme";
import styled from "styled-components";

export const GameDescriptionSIBox = styled(GameDescriptionDefaultTextBox)`
  color: ${props => props.theme.colors.textDark};
`;

export const GameDescriptionTextBox = styledByTheme(GameDescriptionDefaultTextBox).forSI(GameDescriptionSIBox).apply();